var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconScFarcaster = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.00001 2.39996H12V3.99997H14L13.6 5.59996H13.2V12C13.421 12 13.6 12.179 13.6 12.4V12.8C13.821 12.8 14 12.979 14 13.2V13.6H10V13.2C10 12.979 10.179 12.8 10.4 12.8V12.4C10.4 12.179 10.579 12 10.8 12V8.76569C10.7988 7.22033 9.54564 5.96797 8 5.96797C6.45391 5.96797 5.20051 7.22105 5.2 8.76703V12C5.42099 12 5.6 12.179 5.6 12.4V12.8C5.82101 12.8 5.99999 12.979 5.99999 13.2V13.6H2V13.2C2 12.979 2.179 12.8 2.4 12.8V12.4C2.4 12.179 2.579 12 2.79999 12V5.59996H2.4L2 3.99997H4.00001V2.39996Z",
    fill: "#7C65C1"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconScFarcaster);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_sc_farcaster.565854f1187be53e0514bf18af2bb7a3.svg";